<template>
  <svg width="10px" height="6px" viewBox="0 0 10 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="11-Terminvereinbarung-" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="D_011.2_Terminvereinarung" transform="translate(-600.000000, -274.000000)" fill="currentColor">
            <g id="form" transform="translate(501.000000, 247.000000)">
                <g id="Actions-/-Navigation-/-chevron--down-/-24" transform="translate(96.000000, 22.000000)">
                    <polygon id="Fill" points="8 11 3 6 3.7 5.3 8 9.6 12.3 5.3 13 6"></polygon>
                </g>
            </g>
        </g>
    </g>
</svg>
</template>

<script>
export default {
  name: 'IconChevronDown'
};
</script>
